









import JourneyParameters from '@/models/interfaces/JourneyParameters';
import SurveyAnswer from '@/models/SurveyAnswer';
import { Rating } from '@solucx/indicators';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

@Component
export default class AcceptanceContactIfPromoter extends Vue {
  @Prop() public value: boolean;
  @Prop() public rating: SurveyAnswer;
  @Prop({ required: true }) public readonly parameters: JourneyParameters;

  public get acceptanceContactIfPromoter(): boolean {
    return this.value;
  }

  public set acceptanceContactIfPromoter(value: boolean) {
    this.$emit('input', value);
  }

  public get shouldContactIfPromoter(): boolean {
    return this.isPromoter && this.parameters.showAcceptanceContactIfPromoter === true;
  }

  public get isPromoter(): boolean {
    return this.rating.getRating() === Rating.POSITIVE;
  }

  public get customAcceptanceContactText(): string {
    const { customAcceptanceContactText } = this.parameters;
    return customAcceptanceContactText ? customAcceptanceContactText : this.$tc('generic.acceptanceContact');
  }

  @Watch('shouldContactIfPromoter')
  public onChangedActiveContactIfPromoter(): void {
    this.$emit('shouldContactIfPromoterChanged');
  }
}
